import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME  = 'Driven2WIN';
const SITE_URL   = 'https://driven2win.com';
const OG_IMAGE   = 'https://driven2win.com/driven2win-logo.png';
const OG_IMAGE_W = '1200';
const OG_IMAGE_H = '400';
const DEFAULT_DESCRIPTION = 'Driven2WIN — 23+ years producing high-impact sales events for car, golf cart, motorcycle, ATV, and RV dealerships nationwide. Guaranteed results, turnkey execution.';

const SEO = ({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType       = 'website',
  ogImage      = OG_IMAGE,
  ogImageWidth  = OG_IMAGE_W,
  ogImageHeight = OG_IMAGE_H,
  noIndex      = false,
  structuredData,
}) => {
  const fullTitle   = title
    ? `${title} | ${SITE_NAME}`
    : `${SITE_NAME} | Nationwide Automotive Event Marketing`;
  const metaDesc    = description || DEFAULT_DESCRIPTION;
  const canonical   = canonicalUrl || SITE_URL;

  return (
    <Helmet>
      {/* ── Core ── */}
      <html lang="en" />
      <title>{fullTitle}</title>
      <meta name="description"          content={metaDesc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author"               content={SITE_NAME} />
      <link rel="canonical"             href={canonical} />
      {noIndex && <meta name="robots"   content="noindex, nofollow" />}
      {!noIndex && <meta name="robots"  content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />}

      {/* ── Open Graph ── */}
      <meta property="og:site_name"     content={SITE_NAME} />
      <meta property="og:type"          content={ogType} />
      <meta property="og:url"           content={canonical} />
      <meta property="og:title"         content={fullTitle} />
      <meta property="og:description"   content={metaDesc} />
      <meta property="og:image"         content={ogImage} />
      <meta property="og:image:width"   content={ogImageWidth} />
      <meta property="og:image:height"  content={ogImageHeight} />
      <meta property="og:image:alt"     content={`${SITE_NAME} — High-Powered Promotions`} />
      <meta property="og:locale"        content="en_US" />

      {/* ── Twitter / X Card ── */}
      <meta name="twitter:card"         content="summary_large_image" />
      <meta name="twitter:site"         content="@driven2win" />
      <meta name="twitter:title"        content={fullTitle} />
      <meta name="twitter:description"  content={metaDesc} />
      <meta name="twitter:image"        content={ogImage} />
      <meta name="twitter:image:alt"    content={`${SITE_NAME} — High-Powered Promotions`} />

      {/* ── Structured Data (JSON-LD) ── */}
      {structuredData && Array.isArray(structuredData)
        ? structuredData.map((schema, i) => (
            <script key={i} type="application/ld+json">
              {JSON.stringify(schema)}
            </script>
          ))
        : structuredData && (
            <script type="application/ld+json">
              {JSON.stringify(structuredData)}
            </script>
          )
      }
    </Helmet>
  );
};

export default SEO;
